// extracted by mini-css-extract-plugin
export var container = "location-module--container--Eacak";
export var flex = "location-module--flex--B3yVU";
export var img = "location-module--img--55CbB";
export var item = "location-module--item--cn88k";
export var location_features_container = "location-module--location_features_container--4zKIa";